<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Summary & Performance Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getSummaryPerformanceData()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title">Summary Report</div>

        <div
          v-if="
            Object.keys(summaryData).length ||
            Object.keys(boxOfficeData).length ||
            Object.keys(concessionData).length
          "
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <a
            target="_blank"
            @click="getSummaryReport('Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>

      <div class="mx-2 row">
        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Summary
          </div>

          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                 Total Admits (Incl. Comp.) :
              </td>

              <td class="text-right small px-1">
                {{ summaryData.total_admits ? summaryData.total_admits : 0 }}
              </td>
            </tr>

             <tr >
              <td class="text-left small font-weight-bold px-1">
                Total Complimentary Admits :
              </td>

              <td class="text-right small px-1">
                {{ summaryData.complimentary_admits ? summaryData.complimentary_admits : 0 }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Transactions :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_transactions
                    ? summaryData.total_transactions
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Seats In Cinema :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_seats_in_cinema
                    ? summaryData.total_seats_in_cinema
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Screen :
              </td>

              <td class="text-right small px-1">
                {{ summaryData.total_screen ? summaryData.total_screen : 0 }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total No of Shows :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_no_of_shows
                    ? summaryData.total_no_of_shows
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Avg. of Shows :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.avg_shows ? currFormat(summaryData.avg_shows) : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Capacity Available :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_capacity_available
                    ? summaryData.total_capacity_available
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Revenue :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_capacity_available
                    ? currFormat(summaryData.total_revenue_conv)
                    : 0
                }}
              </td>
            </tr>

            <tr
              v-if="
                Object.keys(summaryData).length &&
                Object.keys(summaryData['IMAX3D']).length > 0
              "
            >
              <td class="text-left small font-weight-bold px-1">Imax 3D</td>
              <td class="text-right small px-1">
                {{ summaryData["IMAX3D"].qty }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(summaryData).length &&
                Object.keys(summaryData['3DOnlyQty']).length > 0
              "
            >
              <td class="text-left small font-weight-bold px-1">3D Only:</td>
              <td class="text-right small px-1">
                {{ summaryData["3DOnlyQty"].qty }}
              </td>
            </tr>
            <template
              v-if="
                Object.keys(boxOfficeData).length &&
                boxOfficeData.final_addons_array.length > 0
              "
            >
              <tr>
                <td class="text-center small font-weight-bold px-1" colspan="2">
                  {{ $t("additionalChanges") }}
                </td>
                <!-- <td class="p-1">Amount</td> -->
              </tr>
              <tr
                v-for="(
                  addOnitem, addOnsitemIndex
                ) in boxOfficeData.final_addons_array"
                :key="addOnsitemIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ addOnitem.addons_name }}
                </td>
                <td class="text-right small px-1">
                  {{ addOnitem.quantity }}
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Box Office
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Box Office Revenue(BOR) :
              </td>

              <td class="text-right small px-1">
                {{
                  boxOfficeData.bo_revenue_conv
                    ? currFormat(boxOfficeData.bo_revenue_conv)
                    : 0
                }}
              </td>
            </tr>

            <template
              v-if="
                boxOfficeData.transactionTaxData &&
                boxOfficeData.transactionTaxData.length
              "
            >
              <tr
                v-for="(
                  taxData, taxDataIndex
                ) in boxOfficeData.transactionTaxData"
                :key="taxDataIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ taxData.charge_type_name }} :
                </td>
                <td class="text-right small px-1">
                  {{ currFormat(taxData.tax_value_conv) }}
                </td>
              </tr>
            </template>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Service Charge :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.service_charge_conv) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Add. Chgs (Addl. Tax / FDF) :
              </td>
              <td class="text-right small px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Net BOR :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_bor_conv
                    ? currFormat(boxOfficeData.net_bor_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.total_transactions
                    ? boxOfficeData.total_transactions
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">ATP :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.atp_conv
                    ? currFormat(boxOfficeData.atp_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Net ATP :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_atp_conv
                    ? currFormat(boxOfficeData.net_atp_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Occupancy :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.occupancy
                    ? currFormat(boxOfficeData.occupancy)
                    : 0
                }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(boxOfficeData).length &&
                Object.keys(boxOfficeData['IMAX3D']).length
              "
            >
              <td class="text-left small font-weight-bold px-1">IMAX 3D</td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData["IMAX3D"].gross_amount) || "0" }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(boxOfficeData).length &&
                Object.keys(boxOfficeData['3DOnlyQty']).length
              "
            >
              <td class="text-left small font-weight-bold px-1">3D Only:</td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData["3DOnlyQty"].gross_amount) || "0" }}
              </td>
            </tr>
            <template
              v-if="
                Object.keys(boxOfficeData).length &&
                boxOfficeData.final_addons_array.length > 0
              "
            >
              <tr>
                <td class="text-center small font-weight-bold px-1" colspan="2">
                  {{ $t("additionalChanges") }}
                </td>
                <!-- <td class="p-1">Amount</td> -->
              </tr>
              <tr
                v-for="(
                  addOnitem, addOnsitemIndex
                ) in boxOfficeData.final_addons_array"
                :key="addOnsitemIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ addOnitem.addons_name }}
                </td>
                <td class="text-right small px-1">
                  {{ currFormat(addOnitem.final_price) }}
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Concessions
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross Revenue :
              </td>

              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue
                    ? currFormat(concessionData.gross_revenue)
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">TAX :</td>
              <td class="text-right small px-1">
                {{ concessionData.vat ? currFormat(concessionData.vat) : 0 }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Concession Net Revenue :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.concession_net_revenue
                    ? currFormat(concessionData.concession_net_revenue)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Spend Per Head :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && summaryData.total_admits
                    ? currFormat(
                        concessionData.gross_revenue / summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Cost of Goods Sold :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.cost_goods_sold
                    ? currFormat(concessionData.cost_goods_sold)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Food Cost :</td>
              <td class="text-right px-1">
                {{
                  concessionData.food_cost
                    ? currFormat(concessionData.food_cost)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transactions :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.transactions ? concessionData.transactions : 0
                }}
              </td>
            </tr>
         
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Admission Strike Rate :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && summaryData.total_transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          summaryData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small bold-text font-weight-bold px-1">
                Average. Value Per Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && concessionData.transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          concessionData.transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small bold-text font-weight-bold px-1">
               Quantity of Item Sold (Inc. Comp.) :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold
                    ? concessionData.qty_items_sold
                    : 0
                }}
              </td>
            </tr>
                <tr>
              <td class="text-left small font-weight-bold px-1">
               Quantity of Item Sold Complimentary :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.complimentary_fnb_items ? concessionData.complimentary_fnb_items : 0
                }}
              </td>
            </tr>
            <tr>
              <td
                class="text-left small bold-text font-weight-bold px-1"
                style="white-space: nowrap"
              >
                Average. Cost Per Admits :
              </td>
              <td class="text-right small px-1" style="white-space: nowrap">
                {{
                  concessionData.cost_goods_sold && summaryData.total_admits
                    ? currFormat(
                        concessionData.cost_goods_sold /
                          summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Performance Indicators
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Items Per Admit :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold && summaryData.total_admits
                    ? currFormat(
                        concessionData.qty_items_sold / summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Items Per Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold && concessionData.transactions
                    ? currFormat(
                        concessionData.qty_items_sold /
                          concessionData.transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transaction Strike Rate :
              </td>
              <td class="text-right px-1">
                   {{
                  concessionData.gross_revenue && boxOfficeData.total_transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          boxOfficeData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross Box Revenue Per Seat :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.bo_revenue_conv &&
                  summaryData.total_capacity_available
                    ? currFormat(
                        boxOfficeData.bo_revenue_conv /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Nett Box Revenue Per Seat :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_bor && summaryData.total_capacity_available
                    ? currFormat(
                        boxOfficeData.net_bor /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Revenue Per Seat :
              </td>
              <td class="text-right px-1">
                {{
                  summaryData.total_revenue &&
                  summaryData.total_capacity_available
                    ? currFormat(
                        summaryData.total_revenue /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Average Sale Per Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  summaryData.total_revenue && summaryData.total_transactions
                    ? currFormat(
                        summaryData.total_revenue /
                          summaryData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Average Sale Per Patron :
              </td>
              <td class="text-right px-1">
                  {{
                  summaryData.total_revenue_conv && summaryData.total_admits
                    ? currFormat(
                        summaryData.total_revenue_conv /
                          summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Miscellaneous & Sales Channel Performance
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Miscellaneous Income :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(summaryData.addons_charges) }}
              </td>
            </tr>
          </table>

          <table
            class="swc-report-table mt-2"
            border="1"
            v-if="SalesChannelPerformance.length && !isEpix"
          >
            <thead class="bg-lightgrey font-weight-bold">
              <th>Channel</th>
              <th>Tickets</th>
              <th>Booking Fees</th>
              <th>Sales</th>
            </thead>
            <tr
              v-for="(
                salesChannelObj, salesChannelObjIndex
              ) in SalesChannelPerformance"
              :key="salesChannelObjIndex"
            >
              <td class="text-left">{{ salesChannelObj.bs_source }}</td>
              <td class="text-right">{{ salesChannelObj.sales_count }}</td>
              <td class="text-right">
                {{ currFormat(salesChannelObj.internet_handling_fee) }}
              </td>
              <td class="text-right">
                {{ currFormat(salesChannelObj.total_sales) }}
              </td>
            </tr>
          </table>
          <table class="swc-report-table border border-0" v-else>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross BO Revenue(Before Offer) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.bo_revenue_before_offer) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Promotion/MKTG Exp Rev :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.offer_price) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                BOR(after Disc.) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.bo_revenue) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross FnB Revenue :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.gross_revenue_before_offer) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">FnB Disc :</td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.total_offer_price) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                FnB Revenue(after Disc.) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.gross_revenue) }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2">
          <div
            class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Concessions Profit Performance
          </div>
            <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit at Standard Cost :</td
              >

              <td class="text-right small px-1">{{
                concessionData.concession_net_revenue && concessionData.cost_goods_sold
                  ? currFormat(
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    )
                  : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold  px-1 "
                >Profit % :</td
              >
              <td class="text-right small  px-1">{{
                currFormat(((
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    ) / concessionData.concession_net_revenue) * 100)
                }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold  px-1"
                >Profit per Item :</td
              >
              <td class="text-right small px-1">{{
                 currFormat((
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    ) / concessionData.qty_items_sold)
                 
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit Per Admit :</td
              >
              <td class="text-right small px-1">{{
                currFormat(
                      (
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    ) / summaryData.total_admits
                    )
                 
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit Per Transaction :</td
              >
              <td class="text-right small px-1">{{
                 currFormat(
                      (
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    ) / concessionData.transactions
                    )
              }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title my-2">Performance Report</div>
        <div
          v-if="performanceRecords.length > 0"
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->

          <a
            target="_blank"
            @click="getPerformanceReport('Y', 'N')"
            title="Download as Excel"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
          <a
            target="_blank"
            @click="getPerformanceReport('N', 'Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>
      <div class="table-scroll">
        <table class="performance-report-table" border="1">
          <thead>
            <tr>
              <td colspan="2"></td>
              <td colspan="3">Audience</td>
              <td colspan="4">
                {{ $t("revenue") }}
              </td>
              <td colspan="2">ATP</td>
            </tr>
            <tr>
              <td>{{ $t("film") }}</td>
              <td>{{ $t("noof") }} {{ $t("show") }}</td>
              <td>{{ $t("admits") }}</td>
              <td>{{ $tc("available", 1) }} {{ $t("capacity") }}</td>
              <td>{{ $t("occupancy") }} %</td>
              <td>BOR</td>
              <td>OverAll Tax</td>
              <!-- <td>{{ secondaryTaxName }}</td> -->
              <td>Nett BOR</td>
              <td>BOR ATP</td>
              <td>Net ATP</td>
            </tr>
          </thead>

          <tbody v-if="performanceRecords.length">
            <tr
              v-for="(performanceObj, performanceIndex) in performanceRecords"
              :key="performanceIndex"
            >
              <td class="text-left">{{ `${performanceObj.movie_name} ${performanceObj.ss_category_name?`(${performanceObj.ss_category_name})`:``} ` }}</td>
              <td class="text-right">{{ performanceObj.total_shows }}</td>
              <td class="text-right">{{ performanceObj.admits }}</td>
              <td class="text-right">
                {{ performanceObj.available_capacity }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.admits && performanceObj.available_capacity
                    ? currFormat(
                        ((performanceObj.admits /
                          performanceObj.available_capacity) *
                          10000) /
                          100
                      )
                    : "0.00"
                }}
              </td>
              <td class="text-right">{{ currFormat(performanceObj.bor) }}</td>
              <td class="text-right">{{ currFormat(performanceObj.overAllTax) }}</td>
              <!-- <td class="text-right">{{ currFormat(performanceObj.gcam) }}</td> -->
              <td class="text-right">
                {{ currFormat(performanceObj.net_bor) }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.bor && performanceObj.admits
                    ? currFormat(performanceObj.bor / performanceObj.admits)
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.net_bor && performanceObj.admits
                    ? currFormat(performanceObj.net_bor / performanceObj.admits)
                    : 0
                }}
              </td>
            </tr>
            <tr class="font-weight-bold bg-lightgrey">
              <td class="text-lef">Grand Total</td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.total_shows }}
              </td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.admits }}
              </td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.available_capacity }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.admits &&
                  performanceRecordsGrandTotal.available_capacity
                    ? currFormat(
                        ((performanceRecordsGrandTotal.admits /
                          performanceRecordsGrandTotal.available_capacity) *
                          10000) /
                          100
                      )
                    : 0
                }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.bor) }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.overAllTax) }}
              </td>
              <!-- <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.gcam) }}
              </td> -->
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.net_bor) }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.bor &&
                  performanceRecordsGrandTotal.admits
                    ? currFormat(
                        performanceRecordsGrandTotal.bor /
                          performanceRecordsGrandTotal.admits
                      )
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.net_bor &&
                  performanceRecordsGrandTotal.admits
                    ? currFormat(
                        performanceRecordsGrandTotal.net_bor /
                          performanceRecordsGrandTotal.admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title my-2">Concession Sales Analysis</div>
        <div
          v-if="performanceFnbRecords.length > 0"
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->

          <a
            target="_blank"
            @click="getPerformanceFnBRecords('Y', 'N')"
            title="Download as Excel"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
          <a
            target="_blank"
            @click="getPerformanceFnBRecords('N', 'Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>

      <div class="table-scroll">
        <table class="performance-report-table" border="1">
          <thead>
            <tr>
              <td>Items</td>
              <td colspan="4">Items</td>
              <td colspan="3">Per 100 Patrons</td>
              <td colspan="4">Value</td>
            </tr>
            <tr>
              <td></td>
              <td>Qty Sold</td>
              <td>Net Price</td>
              <td>Std Profit</td>
              <td>Std Profit%</td>
              <td>Qty</td>
              <td>Sale</td>
              <td>Profit</td>
              <td>Net Sale</td>
              <td>Sale Mix%</td>
              <td>Net Profit</td>
              <td>Profit Mix%</td>
            </tr>
          </thead>
          <tbody v-if="performanceFnbRecords.length > 0">
            <template
              v-for="(
                performanceFnbObj, performanceFnbIndex
              ) in performanceFnbRecords"
            >
              <tr :key="performanceFnbIndex">
                <td
                  class="text-left font-weight-bold concession_blue"
                  colspan="12"
                >
                  {{ performanceFnbObj.category_name }}
                </td>
              </tr>
              <tr
                v-for="(
                  performanceCategoryObj, performanceCategoryIndex
                ) in performanceFnbObj.categoryItems"
                :class="
                  performanceFnbObj.categoryItems.length - 1 ==
                  performanceCategoryIndex
                    ? 'bg-lightgrey'
                    : ''
                "
                :key="`${performanceCategoryIndex}_category_data_${performanceFnbIndex}`"
              >
                <td class="text-left">
                  {{ performanceCategoryObj.item_name }}
                </td>
                <td class="text-right">
                  {{ performanceCategoryObj.total_quantity }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      performanceCategoryObj.total_amount /
                        performanceCategoryObj.total_quantity
                    )
                  }}
                </td>
                <td class="text-right">
                  {{ currFormat(performanceCategoryObj.std_profit) }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      (performanceCategoryObj.std_profit /
                        (performanceCategoryObj.total_amount /
                          performanceCategoryObj.total_quantity)) *
                        100
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      (performanceCategoryObj.total_quantity * 100) /
                        summaryData.total_admits
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      ((performanceCategoryObj.total_amount /
                        performanceCategoryObj.total_quantity) *
                        (performanceCategoryObj.total_quantity * 100)) /
                        summaryData.total_admits
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      (performanceCategoryObj.std_profit *
                        (performanceCategoryObj.total_quantity * 100)) /
                        summaryData.total_admits
                    )
                  }}
                </td>
                <td class="text-right">
                  {{ currFormat(performanceCategoryObj.total_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(performanceCategoryObj.sale_mix) }}
                </td>
                <td class="text-right">
                  {{ currFormat(performanceCategoryObj.net_profit_new) }}
                </td>
                <td class="text-right">
                  {{ currFormat(performanceCategoryObj.profit_mix) }}
                </td>
              </tr>
            </template>
            <tr class="bg-lightgrey">
              <td class="text-left">Grand Total</td>
              <td class="text-right">
                {{ performanceFnbRecordsGrandTotal.total_quantity }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceFnbRecordsGrandTotal.total_amount /
                      performanceFnbRecordsGrandTotal.total_quantity
                  )
                }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceFnbRecordsGrandTotal.std_profit) }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (performanceFnbRecordsGrandTotal.std_profit /
                      (performanceFnbRecordsGrandTotal.total_amount /
                        performanceFnbRecordsGrandTotal.total_quantity)) *
                      100
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (performanceFnbRecordsGrandTotal.total_quantity * 100) /
                      summaryData.total_admits
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    ((performanceFnbRecordsGrandTotal.total_amount /
                      performanceFnbRecordsGrandTotal.total_quantity) *
                      (performanceFnbRecordsGrandTotal.total_quantity * 100)) /
                      summaryData.total_admits
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (performanceFnbRecordsGrandTotal.std_profit *
                      (performanceFnbRecordsGrandTotal.total_quantity * 100)) /
                      summaryData.total_admits
                  )
                }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceFnbRecordsGrandTotal.total_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceFnbRecordsGrandTotal.sale_mix) }}
              </td>
              <td class="text-right">
                
                {{ currFormat(performanceFnbRecordsGrandTotal.net_profit_new) }}

              </td>
              <td class="text-right">
                {{ currFormat(performanceFnbRecordsGrandTotal.profit_mix) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      performanceRecords: [],
      performanceRecordsGrandTotal: {},
      summaryData: {},
      boxOfficeData: {},
      concessionData: {},
      performanceMovieRecords: [],
      performanceFnbRecords: [],
      performanceFnbRecordsTotal: {},
      performanceFnbRecordsGrandTotal: {},
      patronsTotal: {
        qtyTotal: 0,
        salesTotal: 0,
        profitTotal: 0,
      },
      excelFilePath: "",
      performancePdf: "",
      grandTotal: {},
      SalesChannelPerformance: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {
    console.log('isPlayyy:', this.isPlay);
  },
  computed: {
    getPerPatronsTotal() {
      this.performanceFnbRecords.map((x) => {
        x.FoodCategory.map((y) => {
          this.patronsTotal["qtyTotal"] += +parseFloat(
            (y.fst_quantity * 100) / parseFloat(this.summaryData.total_admits)
          );
          this.patronsTotal["salesTotal"] += +parseFloat(
            (y.net_price_conv * (y.fst_quantity * 100)) /
              parseFloat(this.summaryData.total_admits)
          );
          this.patronsTotal["profitTotal"] += +parseFloat(
            (y.std_profit_conv * (y.fst_quantity * 100)) /
              parseFloat(this.summaryData.total_admits)
          );
        });
      });
      return this.patronsTotal;
    },
    getProfitStdCost() {
      let profitValue =
        this.concessionData.cost_goods_sold_conv &&
        this.concessionData.transactions
          ? this.concessionData.cost_goods_sold_conv *
            this.concessionData.transactions
          : 0;
      return profitValue;
    },
    secondaryTaxName() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.mtax_clients)
        ? "M-Tax"
        : "GCAM";
    },
    isEpix() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.EPIX);
    },
    isPlay() {
      return CLIENT_NAMES_OBJ.playcinema == this.CLIENT_SETUP_NAME;;
    },
  },
  methods: {
    onChangeDate(e, type) {
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    concessionExcelDownload() {
      let temp_obj = this.performanceFnbRecords;
      let temp_arr = [];
      temp_obj.map((x) => {
        x.FoodCategory.map((y) => {
          let obj = { ...x, ...y, ...this.summaryData };
          temp_arr.push(obj);
        });
      });
      let data = [
        {
          sheet: "Concession Sales Report",
          columns: [
            {
              value: "item_name",
              label: "Item Name",
            },
            {
              value: "fst_quantity",
              label: "Qty Sold",
            },
            {
              value: (row) =>
                row.net_price_conv
                  ? +parseFloat(row.net_price_conv).toFixed(
                      this.MIN_FRACTION_DIGITS
                    )
                  : "-",
              label: "Net Price",
            },
            {
              value: (row) =>
                row.std_profit_conv
                  ? +parseFloat(row.std_profit_conv).toFixed(
                      this.MIN_FRACTION_DIGITS
                    )
                  : "-",
              label: "Std Profit",
            },

            {
              value: (row) =>
                row.fst_quantity
                  ? +parseFloat(
                      (row.fst_quantity * 100) / row.total_admits
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Qty Per 100 Patrons",
            },
            {
              value: (row) =>
                row.net_price_conv
                  ? +parseFloat(
                      row.net_price_conv *
                        ((row.fst_quantity * 100) / row.total_admits)
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Sales Per 100 Patrons",
            },
            {
              value: (row) =>
                row.std_profit_conv
                  ? +parseFloat(
                      row.std_profit_conv *
                        ((row.fst_quantity * 100) / row.total_admits)
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Profit Per 100 Patrons",
            },
            {
              value: (row) =>
                row.std_profit_conv && row.net_price_conv
                  ? +parseFloat(
                      (row.std_profit_conv / row.net_price_conv) * 100
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0,
              label: "Std Profit %",
            },
            {
              value: (row) =>
                row.net_sales_conv
                  ? +parseFloat(row.net_sales_conv).toFixed(
                      this.MIN_FRACTION_DIGITS
                    )
                  : "-",
              label: "Net Sale",
            },
            {
              value: (row) =>
                row.net_sales_conv && row.total_net_sales_conv
                  ? +parseFloat(
                      (row.net_sales_conv / row.total_net_sales_conv) * 100
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "Sale Mix %",
            },
            {
              value: (row) =>
                +parseFloat(row.net_profit_conv).toFixed(
                  this.MIN_FRACTION_DIGITS
                ),
              label: "Net Profit",
            },
            {
              value: (row) =>
                row.net_profit_conv && row.total_std_profit_conv
                  ? +parseFloat(
                      (+parseFloat(row.net_profit_conv) /
                        +parseFloat(row.total_std_profit_conv)) *
                        100
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "Profit Mix %",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_arr,
        },
      ];
      let settings = {
        fileName: `ConcessionReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getSummaryPerformanceData: async function () {
      Promise.all([
        this.getSummaryReport("N"),
        this.getSalesChannelWise(),
        this.getPerformanceReport("N", "N"),
        this.getPerformanceFnBRecords("N", "N"),
      ]).then(() => {});
    },
    getSalesChannelWise() {
      this.SalesChannelPerformance = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isReport: 'Y'
      };
      ReportsService.GetSalesChannelPerformance(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.SalesChannelPerformance = [...data.Records];
          }
          this.$toasted.show(data.message);
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getPerformanceReport(isExcel = "N", isPdf = "N") {
      this.performanceRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
        isReport: 'Y'
      };
      ReportsService.GetPerformanceReportV5(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.performanceRecords = [...data.Records];
            this.performanceRecordsGrandTotal = data.grandTotal;
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              // console.log("Opening PDF:", data.pdfPath);
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getSummaryReport(isPdf = "N") {
      this.summaryData = {};
      this.boxOfficeData = {};
      this.concessionData = {};
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }

      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
        isReport: 'Y'
      };
      ReportsService.GetSummaryV4(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records) {
            this.summaryData = { ...data.Records.summary };
            this.boxOfficeData = { ...data.Records.boxOffice };
            this.concessionData = { ...data.Records.concession };
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          }
          this.$toasted.show(data.message);
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getPerformanceFnBRecords(isExcel = "N", isPdf = "N") {
      this.performanceFnbRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
        isReport: 'Y'
      };
      if (isExcel == "Y") {
        payload["total_admits"] = this.summaryData.total_admits;
      }
      if (isPdf == "Y") {
        payload["total_admits"] = this.summaryData.total_admits;
      }
      ReportsService.GetConcessionPerformanceReportV5(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.performanceFnbRecords = [...data.Records];
            this.performanceFnbRecordsGrandTotal = data.grandTotal;
            // this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}

.light_grey_concession {
  background-color: #787878;
}

.concession_blue {
  background-color: #c5d6f0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/summaryAndPerformanceReportAllClientV5.vue